import { cn } from "@/lib/utils";
import type * as React from "react";

export function Skeleton({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn("animate-pulse rounded-md bg-surface3", className)}
			{...props}
		/>
	);
}
